import React from 'react'
import { Shade, Skeleton } from '.'

type Props = {
  type: 'h1' | 'h2' | 'h3' | 'h4' | 'p'
  width?: number
  shade?: Shade
  noAnimation?: boolean
}

export const TextSkeleton = ({ type, width, shade, noAnimation = false }: Props) => {
  const height = {
    h1: 40,
    h2: 28,
    h3: 20,
    h4: 16,
    p: 14,
  }[type]

  if (type === 'p') {
    return (
      <div className="d-flex flex-wrap">
        <Skeleton
          width={width}
          height={height}
          borderRadius={2}
          shade={shade}
          className="u-mb-12"
          noAnimation={noAnimation}
        />
        <Skeleton
          width={width}
          height={height}
          borderRadius={2}
          shade={shade}
          className="u-mb-12 u-flex-basis-80"
          noAnimation={noAnimation}
        />
        <Skeleton
          width={width}
          height={height}
          borderRadius={2}
          shade={shade}
          className="u-mb-12 u-flex-basis-60"
          noAnimation={noAnimation}
        />
      </div>
    )
  }

  return (
    <Skeleton width={width} height={height} borderRadius={2} shade={shade} className="u-mb-12" />
  )
}
